"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledImageSizeItem = exports.StyledImageSize = exports.StyleItem = exports.StyleImageWrapper = exports.StyledContent = exports.StyledContentModal = exports.StyledStylesWrapper = exports.StyledTitleWrapper = exports.StyledWrapper = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledWrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;
  flex-flow: column;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  margin-bottom: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
`;
exports.StyledTitleWrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
`;
exports.StyledStylesWrapper = styled_components_1.default.div `
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  background: transparent;
`;
exports.StyledContentModal = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-right: ${ui_common_components_1.utils.rem(10)};
  padding-bottom: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Medium)};
  background: ${({ theme }) => theme.Color.Neutrals.Paper};
  overflow-y: auto;

  ${({ opened }) => opened
    ? (0, styled_components_1.css) `
          display: flex;
        `
    : (0, styled_components_1.css) `
          display: none;
        `}
`;
exports.StyledContent = styled_components_1.default.div `
  position: relative;
  width: 100%;
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: auto;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  margin: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)} 0;
`;
exports.StyleImageWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ type, theme }) => {
    const maxWidth = (theme.Components.ToolBar.contentContainer -
        (theme.Components.ToolBar.padding + theme.Spacing.Size.XSmall) * 2) /
        3;
    return (0, styled_components_1.css) `
      box-shadow: inset ${ui_common_components_1.utils.toRemString([0, 0, 0, 1])}
        ${theme.Color.Neutrals.Border};
      transition: all ${theme.Transition.Timing.Out};
      max-width: ${type === 'size' ? ui_common_components_1.utils.rem(maxWidth) : 'auto'};
      width: ${type === 'size' ? ui_common_components_1.utils.rem(82) : '100%'};
      height: ${type === 'size' ? ui_common_components_1.utils.rem(82) : ui_common_components_1.utils.rem(60)};
      margin-bottom: ${ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};
      border-radius: ${ui_common_components_1.utils.rem(theme.Border.Radius.Medium)};
      box-sizing: border-box;
      background-size: cover;
      box-shadow: inset ${ui_common_components_1.utils.toRemString([0, 0, 0, 1])}
        ${theme.Color.Neutrals.Border};
      transition: all ${theme.Transition.Timing.Out};

      svg {
        fill: ${theme.Color.Neutrals.Border};
      }
    `;
}}
`;
exports.StyleItem = styled_components_1.default.a `
  display: flex;
  position: relative;
  padding-bottom: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Medium)};
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  transition: all ${({ theme }) => theme.Transition.Timing.Out};

  span {
    position: absolute;
    bottom: 0;
    display: block;
    white-space: nowrap;
    max-width: 100%;
    width: 100%;
    overflow: hidden;
    transition: all ${({ theme }) => theme.Transition.Timing.Out};
  }

  ${({ selected }) => selected &&
    (0, styled_components_1.css) `
      ${exports.StyleImageWrapper} {
        box-shadow: inset ${ui_common_components_1.utils.toRemString([0, 0, 0, 1.5])}
          ${({ theme }) => theme.Color.Brand.Primary};
      }

      .aspect-ratio-icon::before {
        border-color: ${({ theme }) => theme.Color.Brand.Primary} !important;
      }

      span {
        color: ${({ theme }) => theme.Color.Brand.Primary};
      }

      svg {
        fill: ${({ theme }) => theme.Color.Brand.Primary};
      }
    `}

  &:hover {
    transition: all ${({ theme }) => theme.Transition.Timing.In};

    cursor: pointer;
    ${({ theme }) => (0, styled_components_1.css) `
      ${exports.StyleImageWrapper} {
        box-shadow: inset ${ui_common_components_1.utils.toRemString([0, 0, 0, 1.5])}
          ${theme.Color.Brand.Primary};
      }

      ${exports.StyleImageWrapper}::before {
        border-color: ${({ theme }) => theme.Color.Brand.Primary} !important;
      }

      span {
        color: ${({ theme }) => theme.Color.Brand.Primary};
      }

      svg {
        fill: ${({ theme }) => theme.Color.Brand.Primary};
      }
    `}
  }
`;
exports.StyledImageSize = styled_components_1.default.div `
  position: relative;
  width: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: flex-start;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
  align-items: center;
  ${ui_common_components_1.utils.getFontStyle('Small')};

  ${exports.StyleItem} {
    padding: 0;
  }
`;
exports.StyledImageSizeItem = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-flow: column;
  text-align: center;
  min-height: ${ui_common_components_1.utils.rem(48)};
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};
  color: ${({ theme }) => theme.Color.Neutrals.Border};
`;
//# sourceMappingURL=AiImageStyles.style.js.map